/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @type {string} Project Category action types.
 */

export const SET_LOADING = '[PROJECT_CATEGORY] SET_LOADING';
export const SET_PROJECT_CATEGORY_LIST = '[PROJECT_CATEGORY] SET_PROJECT_CATEGORY_LIST';

